export function toRowId(row: Record<string, any>, key: string = 'uid'): string {
  const value = row[key];
  if (typeof value === 'string') {
    return value;
  }
  throw new TypeError(
    `Expected id to be string but got ${typeof value}. Check idAccessor (${key}) points to unique string value in your data`
  );
}
